// extracted by mini-css-extract-plugin
module.exports = {"list":"NotFoundTab_list__AsSfA","tab":"NotFoundTab_tab__S6_Fx"};